import { Checkbox, Col, Input, Row, Select } from 'antd';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import {
  CompaniesInfiniteSelectField,
  DocumentTypesInfiniteSelectField,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import moment from 'moment';
import {
  AccountReceivableListRequest,
  AccountReceivableSituation,
  AccountRecivableSituationType,
} from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { DateTimeFormat } from '@/utils/moment';

function BillToReceiveExtraFilter({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<AccountReceivableListRequest>) {
  function handleParams(params: typeof queryParams) {
    setQueryParams((state) => ({ ...state, ...params }));
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.code}
          onChange={({ target: { value } }) => handleParams({ code: value })}
          placeholder="Código"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <CompaniesInfiniteSelectField
          placeholder="Empresa"
          allowClear
          style={{ width: '100%' }}
          onChange={(values) => handleParams({ companyId: values })}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.documentNumber}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, documentNumber: value }))
          }
          placeholder="Nº documento"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.debtor}
          onChange={({ target: { value } }) => handleParams({ debtor: value })}
          placeholder="Devedor"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            handleParams({ description: value })
          }
          placeholder="Descrição"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <DocumentTypesInfiniteSelectField
          placeholder="Tipo Doc."
          allowClear
          style={{ width: '100%' }}
          onChange={(values) => handleParams({ documentTypeId: values })}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <InputDate
          placeholder="Emissão"
          value={
            queryParams?.emissionDate
              ? moment(queryParams?.emissionDate)
              : undefined
          }
          onChange={(value) =>
            handleParams({ emissionDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <InputDate
          placeholder="Vencimento"
          value={
            queryParams?.dueDate ? moment(queryParams?.dueDate) : undefined
          }
          onChange={(value) =>
            handleParams({ dueDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <InputDate
          placeholder="Pagamento"
          value={
            queryParams?.payDate ? moment(queryParams?.payDate) : undefined
          }
          onChange={(value) =>
            handleParams({ payDate: value?.format(DateTimeFormat) })
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.situation}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, situation: value }))
          }
          placeholder="Situação"
          options={[
            {
              value: AccountReceivableSituation.open,
              label:
                AccountRecivableSituationType[AccountReceivableSituation.open],
            },
            {
              value: AccountReceivableSituation.settled,
              label:
                AccountRecivableSituationType[
                  AccountReceivableSituation.settled
                ],
            },
          ]}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <InputDecimal
          value={queryParams?.installmentValue}
          onChange={(value) => handleParams({ installmentValue: value })}
          placeholder="Valor"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) => handleParams({ order: value })}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Input
          value={queryParams?.authorizationNumber}
          onChange={({ target: { value } }) =>
            handleParams({ authorizationNumber: value })
          }
          placeholder="Número de autorização"
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              setQueryParams((prev) => ({
                ...prev,
                rows: 500,
              }));
            } else {
              setQueryParams((prev) => ({
                ...prev,
                rows: 10,
              }));
            }
          }}
          style={{ fontWeight: 'bold' }}
        >
          Listar todos
        </Checkbox>
      </Col>

      <Col span={24}>
        <Input.TextArea
          placeholder="Observação"
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, observation: value }))
          }
          autoSize={{ minRows: 3, maxRows: 3 }}
        />
      </Col>
    </Row>
  );
}

export default BillToReceiveExtraFilter;
